import {Component} from '@angular/core';
import {BaseSupportModalComponent} from "./base_support.component";


@Component({
	templateUrl: './clone_site.component.html'
})
export class CloneSiteModalComponent extends BaseSupportModalComponent {
	userId: string;
	siteId: string;
	url: string;
	domain: string;
	email: string;
	isBtnOkActive: boolean = true;

	async ok() {
		if(confirm(`Вы уверены, что хотите дублировать сайт ${this.url}?`)) {
			this.isBtnOkActive = false;

			await this.supportService.cloneSite(this.userId, this.siteId, this.domain, this.email, this.comment).toPromise();

			this.isBtnOkActive = true;

			this.execute();
		}
	}
}
